import i18n from 'i18next';
import {match} from 'ts-pattern';

import {isNil} from 'ramda';

import type {BulkOperationState} from '../types/api/bulkOperations';

const getOutcomeLabel = (state: BulkOperationState | undefined) =>
  match(state)
    .with(undefined, 'PENDING', 'IN_PROGRESS', () => null)
    .with('FAILED', 'RESOLVE_FAILED', () => i18n.t('general.notifications.labels.failed'))
    .with('DONE', 'PARTIALLY_DONE', () => i18n.t('entity.import.labels.finished'))
    .with('CANCELLED', () => i18n.t('entity.campaigns.labels.cancelled'))
    .exhaustive();

/** Names a finished run after its outcome, for example "Add tags cancelled". */
export function getBulkOperationTitle(actionTitle: string, state: BulkOperationState | undefined) {
  const outcome = getOutcomeLabel(state);
  return isNil(outcome)
    ? actionTitle
    : `${actionTitle} ${outcome.toLocaleLowerCase(i18n.resolvedLanguage)}`;
}
